import { Component, ChangeDetectionStrategy } from "@angular/core";
import { AdminAppserviceApiService } from "@shared/services/admin/admin-appservice-api.service";
import { AdminNebApiService } from "@shared/services/admin/admin-neb-api.service";
import { ToasterService } from "@shared/services/toaster.service";
import { ActivatedRoute, Router } from "@angular/router";
import { LogService } from "@shared/services/log.service";
import {
    AdminNebAppserviceConfigComponent,
    AppserviceConfigDialogContext
} from "../appservice-config/appservice-config.component";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { IboxComponent } from "../../../elements/ibox/ibox.component";
import { FormsModule } from "@angular/forms";


@Component({
    templateUrl: "./add-selfhosted.component.html",
    styleUrls: ["./add-selfhosted.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IboxComponent, FormsModule, TranslatePipe]
})
export class AdminAddSelfhostedNebComponent {

    public isSaving = false;
    public userPrefix = "@_neb";
    public adminUrl = "http://localhost:4050";

    constructor(
        private readonly asApi: AdminAppserviceApiService,
        private readonly nebApi: AdminNebApiService,
        private readonly toaster: ToasterService,
        private readonly router: Router,
        private readonly activatedRoute: ActivatedRoute,
        private readonly modal: NgbModal,
        public translate: TranslateService,
        private readonly logService: LogService,
    ) {
        this.translate = translate;
    }

    public save(): void {
        this.isSaving = true;
        this.asApi.createAppservice(this.userPrefix).then(appservice => {
            return this.nebApi.newAppserviceConfiguration(this.adminUrl, appservice);
        }).then(neb => {
            this.translate.get('New go-neb created').subscribe((res: string) => {
                this.toaster.pop("success", res);
            });

            const selfhostedRef = this.modal.open(AdminNebAppserviceConfigComponent, {
                backdrop: 'static',
                size: 'lg',
            });
            selfhostedRef.result.then(() => this.router.navigate(["../.."], {relativeTo: this.activatedRoute}));
            const selfhostedInstance = selfhostedRef.componentInstance as AppserviceConfigDialogContext;
            selfhostedInstance.neb = neb;
        }).catch(err => {
            this.logService.error(err);
            this.isSaving = false;
            this.translate.get('Error creating appservice').subscribe((res: string) => {
                this.toaster.pop("error", res);
            });
        });
    }
}
